module.exports = () => string => _.kebabCase(string);



// WEBPACK FOOTER //
// ./main/filters/kebab-case-filter.js